/**
 * shortcut-help-modal.omponent.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component, OnInit } from "@angular/core";
import { DialogRef, ModalComponent } from "angular2-modal";
import { BSModalContext } from "angular2-modal/plugins/bootstrap";
import { Observable } from "rxjs/Rx";

@Component({
  template: `
  <div class="modal-header">
    <button
      type="button"
      class="close"
      (click)="dialog.dismiss()"
      aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">
      Keyboard Shortcuts
    </h4>
  </div>
  <div class="modal-body">
    <p>
      Mac OSX users may replace <kbd>Ctrl</kbd> with <kbd>Cmd</kbd> below.
    </p>
    <ul>
      <li><kbd>F1</kbd>|<kbd>Ctrl+/</kbd> Show this help</li>
      <li><kbd>Ctrl+H</kbd> Go Home</li>
      <li><kbd>Ctrl+M</kbd> Add Reminder</li>
      <li><kbd>Ctrl+I</kbd> New Intake</li>
      <li>
        On intake form:
        <ul>
          <li><kbd>Ctrl+S</kbd> Save Intake</li>
          <li><kbd>Ctrl+J</kbd> Jump to Step...</li>
          <li><kbd>Ctrl+Enter</kbd> Open Chat</li>
        </ul>
      </li>
    </ul>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-default"
      (click)="dialog.dismiss()">
      OK
    </button>
  </div>
  `
})
export class ShortcutHelpModalComponent
  implements ModalComponent<BSModalContext>
{
  constructor (
    public dialog : DialogRef<BSModalContext>
  ) {}
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/common/shortcut-help-modal.component.ts